import React from "react";
import { Button } from "./Button";
import { getUserFacingError } from "../utils/userFacingError";
import "./RouteErrorContent.css";

/**
 * Safe route recovery, independent of router internals so it is renderable in
 * the generated component lab without a failing live loader.
 * @story args { error: { status: 503 } }
 * @story state ExpiredSession { error: { status: 401 } }
 * @story state PermissionDenied { error: { status: 403 } }
 */
export function RouteErrorContent({ error }: { error: unknown }) {
  return (
    <main className="routeErrorPage" role="alert">
      <h1 className="title">Não foi possível abrir esta página</h1>
      <p className="message">
        {getUserFacingError(error, {
          fallback:
            "Ocorreu uma falha ao carregar esta página. Recarregue para tentar novamente; se persistir, entre em contato com o suporte.",
        })}
      </p>
      <Button callback={() => window.location.reload()}>Recarregar página</Button>
    </main>
  );
}
